import SettingsIcon from '@mui/icons-material/Settings';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type React from 'react';
import { NAVY } from 'styles/tokens';

import { getStatusColor, getStatusLabel } from '../utils';

interface IntegrationHeaderProps {
  name: string;
  totalExecutions: number;
  successRate: number | null;
  onConfigClick?: (e: React.MouseEvent) => void;
}

const IntegrationHeader: React.FC<IntegrationHeaderProps> = ({ name, totalExecutions, successRate, onConfigClick }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
      }}
    >
      <Box>
        <Typography variant="h6" sx={{ color: NAVY, fontWeight: 600 }}>
          {name}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: alpha(NAVY, 0.6),
          }}
        >
          {totalExecutions} ejecuciones en las últimas 24 horas
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {onConfigClick && (
          <IconButton size="small" onClick={onConfigClick}>
            <SettingsIcon fontSize="small" />
          </IconButton>
        )}
        <Chip label={getStatusLabel(successRate)} color={getStatusColor(successRate)} size="small" />
      </Box>
    </Box>
  );
};

export default IntegrationHeader;
